// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"nTWrOpcLYYpzbYTG5lDPR","companyLogo":"qs_-W6QBQAgrzZ-BAVJ2J","logoImg":"cf76EBndFpDa_DREtQDds","communityStamp":"_2Gyr8vZLWE1q_uiTB4hHjG","associationStamp":"_3tfEqVp0Q00DQpDzLbGvBW","purpleStamp":"_2cK3v9dw9cPZvJJCRUY26Q","withBroker":"_1ggVswOlyFPeC-waI3aooa","infoBlock":"_1G92T33yz7_8SWfQ82HAzI","infoBlock_title":"_2kJQiaiMXv8QTNZB1-1FUW","withCommunity":"_3IendIOndmVPsxjyCRG3h8","addressBlock":"_3gNJOTIKFO1dob2sv9wYVl","defaultLang":"_27cvykONIdYyBx1D9zX8tT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/AboutCompany/AboutCompany.scss
// module id = 1566
// module chunks = 0